// API Key function to fetch customer data from a portal
async function getCustomerData(portalUrl) {
  const token = "NTE1MDEzMWEyZjFlMTNkYTYwZjJiMWVhYTAwODc2MGE1ZjNiOTMyYzM3NmEwNWRkOTA0MTAxOTE1Mjk5MDU1NDAxZDZmMzg0NDRlNWVkZDIyNmZkM2VlZjAzZDJjZDYw";
  const providerDetails = await fetch(portalUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": token
    }
  });

  const res = await providerDetails.json();
  if (res ?. status == 200 && res.success) {
    return res.data;
  } else {
    return null;
  }
}

// Function to convert a date string to a formatted date..
function convertDate(string) {
  let timestamp = Date.parse(string);
  let formattedDate = new Date(timestamp).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
  return formattedDate;
}

// Event listener for when the DOM is loaded
document.addEventListener("DOMContentLoaded", async function() {

// Check if the customer is logged in
// Define URLs for customer and follow-up data
  if (CustomerLoggedin) {
    const providerFollowUpURL = `https://backoffice.femologist.com/api/femologist/patient/follow-up/:email/v1`;
    const patientURL = `https://backoffice.femologist.com/api/femologist/patient/data/${CustomerEmail}/v1`;
    const customerData = await getCustomerData(patientURL);
    let customerDataHTML = "";
    if (customerData) { // Render the customer data table
      let customerDataHTML = renderTableRow(customerData);
      document.getElementById("paitent_details").innerHTML = customerDataHTML;
    } else {
      return false;
    }
  }
});
// Function to render the Supplements Provider data table
function renderTableRow(patientData = []) {
  if (patientData.length === 0) return "";

  const createListItemWithPopup = (data, key) => `
    <li data-label="Instruction Note" data-inst-note="${data[key] || ""}" class="note-open-popup">
      ${data[key]?.length > 15 ? `${data[key].slice(0, 33)}...<b>Read More</b>` : data[key] || "-"}
    </li>`;

  const renderSupplementRow = (supplementData) => {
    console.log(supplementData,'supplementData')
    const productUrl = supplementData.productUrl;
    const productName = supplementData.productName;

    return supplementData.supplementVariants
      .map((variant) => {
        const startDate = convertDate(variant.startDate) || "-";
        const endDate =convertDate(variant.endDate) != "Invalid Date"? convertDate(variant.endDate): "Continue Until Further Instructions";
        
        const instruction = createListItemWithPopup(variant, "instruction");

        // Get follow-up dates for this variant
        const followUpDates = supplementData.supplementCheckupDates || []; // Ensure follow-up dates are correctly tied to the variant

        return `
          <div class="ft-suplement--list">
            <div data-label="Supplement Name">
              <div class="hw__max200">
                <p>${productName}</p>
                <b>Variants</b>
                <ul><li>${variant.variantName || "-"}</li></ul>
              </div>
            </div>
            <div data-label="Start Date"><ul><li>${startDate}</li></ul></div>
            <div data-label="End Date">${endDate}</div>
            <div data-label="Instruction"><ul>${instruction}</ul></div>
            <div data-label="Follow Up Date">
              <ul>
                ${
                  followUpDates.length > 0
                    ? followUpDates.map((follow) => `<li>${convertDate(follow.checkupDate)}</li>`).join("")
                    : "-"
                }
              </ul>
            </div>
            <div data-label="Follow Up Note"> 
            <ul>
          ${
  followUpDates.map((follow) => 
    `<li data-label="Follow Up Note" data-inst-note="${follow.notes}" class="note-open-popup">
      ${
        follow?.notes?.length > 15
          ? `${follow?.notes?.slice(0, 33)}...<b>Read More</b>`
          : follow?.notes
      }
    </li>`
  ).join("") || "-"
}
  </ul>
            </div>
            <div>
              <a class="hw__order-link" href="${productUrl}">Purchase<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right-new" width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Icon" d="M8.00248 0.751051C8.33721 0.416316 8.87993 0.416316 9.21466 0.751051L14.3575 5.89391C14.5183 6.05465 14.6086 6.27267 14.6086 6.5C14.6086 6.72733 14.5183 6.94535 14.3575 7.10609L9.21466 12.2489C8.87993 12.5837 8.33722 12.5837 8.00248 12.2489C7.66775 11.9142 7.66775 11.3715 8.00248 11.0368L11.6821 7.35714L1.75143 7.35714C1.27804 7.35714 0.894287 6.97339 0.894287 6.5C0.894287 6.02661 1.27804 5.64286 1.75143 5.64286L11.6821 5.64286L8.00248 1.96323C7.66775 1.6285 7.66775 1.08579 8.00248 0.751051Z" fill="currentcolor"/></svg></a>
            </div>
          </div>
        `;
      })
      .join("");
  };

  const groupByProviderName = (data) => {
    return data.reduce((acc, patient) => {
      const providerName = `${patient.practitionerDetails.firstName} ${patient.practitionerDetails.lastName}`;
      if (!acc[providerName]) {
        acc[providerName] = {
          providerInitial: patient.practitionerDetails.firstName.charAt(0),
          supplements: []
        };
      }
      acc[providerName].supplements.push(...patient.supplementDetails);
      return acc;
    }, {});
  };

  const groupedData = groupByProviderName(patientData);

  let customerDataHTML = "";

  for (const providerName in groupedData) {
    const provider = groupedData[providerName];
    const providerInitial = provider.providerInitial;

    const supplementsHTML = provider.supplements.map(renderSupplementRow).join("");

    customerDataHTML += `
      <tr>
        <td data-label="Provider" class="ft-provider--col">
          <div class="hw__max200">
            <span class="ft-provider--img">${providerInitial}</span>
            ${providerName}
          </div>
        </td>
        <td colspan="7" class="slide-td">${supplementsHTML}</td>
      </tr>
    `;
  }

  return customerDataHTML;
}



// Event listener for when the DOM is loaded (Provider Follow-Up Details)...
document.addEventListener("DOMContentLoaded", async function() {
  if (CustomerLoggedin) {
    const patientURL = `https://backoffice.femologist.com/api/femologist/patient/follow-up/${CustomerEmail}/v1`;
    const customerData = await getCustomerData(patientURL);
    if (customerData) { // Render the Provider Follow-Up Details table
      let customerDataHTML = ProviderFollowUpdetails(customerData);
      document.getElementById("Provider_Follow_Up_details").innerHTML = customerDataHTML;
    } else {
      return false;
    }
  }
});
function sortByDate(arrayOfObjects) {

// Use the sort method to sort the array by date
  const sortedArray = arrayOfObjects.sort((a, b) => {

// Assuming date is a string, convert it to a Date object for comparison
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);

// Compare the dates
    return dateA - dateB;
  });

// Return the sorted array
  return sortedArray;
}

// Helper function to render the notes in a readable format with "Read More" logic
function renderNotes(notes) {
  return notes.map(note => {
    return `<li data-label="Instruction Note" data-inst-note="${note}" class="note-open-popup">
              ${note ? (note.length > 15 ? `${note.slice(0, 15)}<b>...Read More</b>` : note) : '-'}
            </li>`;
  }).join('');
}

// Helper function to render checkup dates in a list format
function renderCheckupDates(dates) {
  return dates.map(date => {
    return `<li>${convertDate(date)}</li>`;
  }).join('');
}

// Function to render the Provider Follow-Up Details table
function ProviderFollowUpdetails(patientData = []) {
  if (patientData.length === 0) return '';

  let customerDataHTML = '';

  // Loop through the patient data and aggregate follow-up details by provider and checkup date
  patientData.forEach(patient => {
    const followUpData = aggregateFollowUpData(patient.patientCheckupDates);

    followUpData.forEach(providerFollowup => {
      // Render each provider name only once
      customerDataHTML += '<tr>';

      const practitionerName = providerFollowup.practitionerName;
      customerDataHTML += `
        <td data-label="Provider Name" class="ft-provider--col">
          <div class="hw__max200">
            <span class="ft-provider--img">${practitionerName.charAt(0)}</span>
            ${practitionerName}
          </div>
        </td>`;

      // Now add the Follow-Up Dates and Notes grouped together
      customerDataHTML += `<td colspan="2" class="slide-td">`;

      providerFollowup.checkandNotedae.forEach(entry => {
        const notesHTML = renderNotes([entry.notes]);
        customerDataHTML += `
          <div class="ft-suplement--list">
            <div data-label="Follow-Up Date">
              <div class="hw__max200">
                <ul><li>${convertDate(entry.checkupDate)}</li></ul>
              </div>
            </div>

            <div data-label="Notes">
              <ul>${notesHTML || '-'}</ul>
            </div>
          </div>
        `;
      });

      customerDataHTML += '</td>'; // End the colspan cell
      customerDataHTML += '</tr>'; // End the table row
    });
  });

  return `<table>${customerDataHTML}</table>`; // Wrap everything in a <table> tag to ensure it's rendered as a table
}

// Helper function to aggregate follow-up data and group by provider name
function aggregateFollowUpData(patientCheckupDates) {
  return patientCheckupDates.reduce((acc, checkupDate) => {
    const { notes, checkupDate: date, practitionerDetails } = checkupDate;
    const practitionerName = `${practitionerDetails.firstName} ${practitionerDetails.lastName}`;

    // Find if there's already an entry for this provider
    let providerEntry = acc.find(entry => entry.practitionerName === practitionerName);

    if (!providerEntry) {
      providerEntry = {
        checkandNotedae: [],
        practitionerName: practitionerName
      };
      acc.push(providerEntry);
    }

    // Add both checkupDate and notes to the checkandNotedae array as an object
    providerEntry.checkandNotedae.push({ checkupDate: date, notes: notes });

    return acc;
  }, []);
}